<div class="page-container">
  <div class="page-header">
    <h1>Gestion des commandes</h1>
    <p>Liste de toutes les commandes</p>
  </div>

  @if (isLoading) {
    <div class="loading">
      Chargement des commandes...
    </div>
  }

  @if (!isLoading) {
    <div class="search-container">
      <div class="search-box">
        <i class="pi pi-search search-icon"></i>
        <input
          type="text"
          class="search-input"
          placeholder="Rechercher une commande (numéro, utilisateur, statut...)"
          [(ngModel)]="searchText"
          (input)="onSearch()"
        />
        @if (searchText) {
          <i class="pi pi-times clear-icon" (click)="searchText = ''; onSearch()"></i>
        }
      </div>

      <button
        class="btn-print"
        (click)="printSelection()"
        [disabled]="isLoading"
        title="Imprimer la sélection"
      >
        <i class="pi pi-print"></i>
        <span>Imprimer</span>
      </button>
    </div>

    <div class="print-header" style="display: none;">
      <h1 class="print-title">Liste des commandes</h1>
      <p class="print-subtitle">
        {{ selectedCommandes.length > 0 ? selectedCommandes.length + ' commande(s) sélectionnée(s)' : 'Toutes les commandes (' + commandes.length + ')' }}
      </p>
      <p class="print-date">Imprimé le {{ formatDate(currentDate.toISOString()) }}</p>
    </div>

    <div class="grid-container">
      <ag-grid-angular
        class="ag-theme-balham"
        [rowData]="commandes"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowSelection]="rowSelection"
        [theme]="theme"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [domLayout]="'autoHeight'"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      >
      </ag-grid-angular>
    </div>
  }
</div>
